import { useMutation } from "react-query";

import axios, { HttpStatusCode } from "axios";

import { GEO_MAP_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { MapLayer } from "../models/mapLayer";

// Specific error for duplicate layer group names
export class DuplicateLayerNameError extends Error {
  constructor() {
    super("A layer group with this name already exists");
    this.name = "DuplicateLayerNameError";
  }
}

const postMapLayer = async (layer: MapLayer) => {
  try {
    const response = await axios.post(`${GEO_MAP_SERVICE_ADDRESS}/map-layer`, layer);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === HttpStatusCode.Conflict) {
      throw new DuplicateLayerNameError();
    }
    throw new Error("Failed to create layer");
  }
};

const usePostMapLayer = () => {
  return useMutation(postMapLayer);
};

export default usePostMapLayer;
